import Modal from "../../../../common/ui/modal";

const DeleteDesignVariantImage = ({image, removeImage, imageIndex}) => {
    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Image"
                content={[{
                    text: `Are you sure you wish to delete the below image?`,
                    classes: ""
                }, {
                    text: `${image?.displayLabel}`,
                    classes: "text-blue font-bold text-center"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={false}
                handleConfirm={() => {
                    removeImage(image, imageIndex)
                }}
            />
        </>
    )
}

export default DeleteDesignVariantImage
